import { NavigationSearchViewModel } from '../NavigationModule/NavigationSearch/NavigationSearch.types';
import SelectItem from '@/common/interfaces/SelectItem';
import SearchResultsCard from '@/common/interfaces/modules/SearchResultCard';

export interface SearchModuleViewModel {
  SearchModel: NavigationSearchViewModel;
  TabItems: Array<SelectItem>;
  Results: Array<SearchResultsCard>;
  PopularLinks: Array<SearchResultsCard>;
}

export interface SearchResultsGridViewModel {
  Items: Array<SearchResultsCard>;
}

enum SearchResultsCategory {
  All = 1,
  Destinations = 2,
  Itineraries = 3,
  Plan = 4,
  Articles = 5,
  // Journal = 6,
  Team = 7,
}

export default SearchResultsCategory;
